import React, { Component } from 'react'
import { FormGroup, ControlLabel, FormControl, Row, Col } from 'react-bootstrap'
import FontAwesomeIcon from '@fortawesome/react-fontawesome'
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons'


class LeaguePersonnel extends Component {
  constructor(props) {
    super();
    this.state = {
      personnelHint: false,
    }
  }

  render() {
    const {
      coachOptions,
      renderAssistantCoaches
    } = this.props
  
    return(
      // <div>
      //   <h3>League Personnel
      //     <a className="heading-hint" onClick={() => this.setState({ personnelHint: !this.state.personnelHint })}>
      //       <FontAwesomeIcon icon={faInfoCircle} color='white' style={{padding: '0.2em'}}/>
      //       {
      //         this.state.personnelHint ?
      //         <div className="hint-tip-text" id="payment-hint">
      //           <span>Personnel assigned to a program ave access to the Program's Teams, Schedule, Standings and Stats.</span>
      //         </div>
      //         : ''
      //       }
      //     </a>
      //   </h3>
        <Row>
          <Col sm={4}>
            <FormGroup>
              <ControlLabel>Commissioners</ControlLabel>
              <FormControl className="opaque-grey" name="commissioner_1" componentClass="select" id="commissioner_1" >
                {coachOptions}
              </FormControl>
              <br/>
              {/* <FormControl className="opaque-grey" name="commissioner_2" componentClass="select" id="commissioner_2">
                {coachOptions}
              </FormControl> */}
            </FormGroup>
          </Col>
          <Col sm={4}>
            <FormGroup>
              <ControlLabel>Personnel</ControlLabel>
                {renderAssistantCoaches()}
            </FormGroup>
          </Col>
        </Row>
      // </div>
    )
  }
}

export default LeaguePersonnel